export enum SystemNotificationTypeEnum {
  POPUP = 'popup',
  MESSAGE = 'message'
}
